<template>
    <layout class="text-white">
        <!--Menu is loaded by the layout-->
        <section-hero :section-hero="sectionHero" />
        <section-services
            :section-services-slides="sectionServicesSlides"
            :services-categories="servicesCategories" />
        <section-samples-gallery
            v-if="sectionSamplesGallery.images.length"
            :info="sectionSamplesGallery" />
        <section-testimonials
            v-if="showTestimonials"
            :section-testimonials="sectionTestimonials" />
        <section-giving-back :section-giving-back="sectionGivingBack" />
        <section-about-us :section-about-us="sectionAboutUs" />
        <section-join-us />
        <!--Footer is loaded by the layout-->
    </layout>
</template>

<script>
import Layout from '@web/components/PageLayout';
import SectionHero from '@web/pages/sections/HomePage/SectionHero';
import SectionServices from '@web/pages/sections/HomePage/SectionServices';
import SectionTestimonials from '@web/pages/sections/HomePage/SectionTestimonials';
import SectionGivingBack from '@web/pages/sections/HomePage/SectionGivingBack';
import SectionAboutUs from '@web/pages/sections/HomePage/SectionAboutUs';
// import SectionInstagram from '@web/pages/sections/shared/SectionInstagram';
import SectionSamplesGallery from '@web/pages/sections/shared/SectionSamplesGallery';
import SectionJoinUs from '@web/pages/sections/shared/SectionJoinUs';
import isEmpty from 'lodash/isEmpty';

export default {
  components: {
    Layout,
    SectionHero,
    SectionServices,
    SectionTestimonials,
    SectionGivingBack,
    SectionAboutUs,
    // SectionInstagram,
    SectionSamplesGallery,
    SectionJoinUs,
  },
  props: {
    // Shared Props from WebsiteSharedProps.php
    servicesCategories: {
      type: Object,
      required: true,
    },

    // Page Specific Props from HomePageController.php
    sectionHero: {
      type: Object,
      required: true,
    },
    sectionServicesSlides: {
      type: Object,
      required: true,
    },
    sectionSamplesGallery: {
      type: Object,
      required: true,
    },
    sectionTestimonials: {
      type: Object,
      required: true,
    },
    sectionGivingBack: {
      type: Object,
      required: true,
    },
    sectionAboutUs: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showTestimonials() {
      return !isEmpty(this.sectionTestimonials.slides);
    },
  },
};
</script>
